import { RedirectLayout } from 'layouts/redirect-layout/RedirectLayout'

export function PasswordReset() {
  return <RedirectLayout text="Your password has been reset successfully" />
}
